import model from 'modules/tool/toolModel';

const { fields } = model;

export default [
  fields.owner,
  fields.name,
  fields.type,
  fields.size,
  fields.bookings,
];
